import { LobConsolidatedMailOptions } from '../../models/entities/lob-mail-options';

/** Class for sending lob mail; may send as part of a file uploader, may send directly to post with no file. */
export class LobMailSendRequest
{
    /** If they used a unit selector for this mailing, they have an array of unit Ids */
    unitIds?: number[];
    /** If they have a list of owners, they are sending to owner Ids */
    ownerIds?: number[];
    /** If they are sending mailed violations, they have an array of violation Ids */
    violationIds?: number[];
    /** Whether to include invoices i.e. if there is an upload already involved */
    doIncludeInvoices: boolean;
    /** Whether to include future invoices, if sending invoices at all */
    doIncludeFutureInvoices?: boolean;
    /** The number of pages of the uploaded file; if 0, there is no uploaded file */
    numPages: number;
    /** The type of item they are mailing; TODO support 'violation' as a type */
    mailableType: 'pdf' | 'invoice';
    /** Optional path of a file already uploaded */
    path = '';
    /** Whether to send to the unit address or the mailing address of the unit */
    sendTo?: 'unit' | 'mailing' | '';
    /** Which type of tracking they want; can be empty */
    tracking?: 'certified' | 'registered' | '';
    /** Whether first class or stand mail; can't be empty on send to db */
    mailClass?: 'standard' | 'first class' | '';
    /** Whether color or bw; default is bw */
    color?: 'color' | 'bw' | '';
    /** Whether it is double sided printing or not */
    isDoubleSided?: boolean;
    /** Future invoices only */
    doIncludeFutureOnly?: boolean;
    includeUploadedPdfForEachUnit?: boolean;

    constructor(request: any) {
        this.unitIds = request.unitIds;
        this.ownerIds = request.ownerIds;
        this.violationIds = request.violationIds;
        this.doIncludeInvoices = request.doIncludeInvoices || false;
        this.numPages = request.numPages;
        this.mailableType = request.mailableType;
        this.path = request.path;

        // options; flatten out for sending to API esp in case of file upload
        const options = new LobConsolidatedMailOptions(request.options);
        this.sendTo = options.sendTo;
        this.tracking = options.tracking;
        this.mailClass = options.mailClass;
        this.color = options.color;
        this.isDoubleSided = options.isDoubleSided || false;
        this.doIncludeFutureInvoices = options.doIncludeFutureInvoices || false;
        this.doIncludeFutureOnly = options.doIncludeFutureOnly || false;
        this.includeUploadedPdfForEachUnit = options.includeUploadedPdfForEachUnit || false;
    }
}
